(function($){
    $(window).load(function() {
		// Masonry
	    var $grid = $('.month-grid').masonry({
			itemSelector: '.post',
			columnWidth: '.grid-sizer',
			percentPosition: true,
			transitionDuration: 0
		});
		$grid.imagesLoaded().progress(function() {
			$grid.masonry('layout');
		});
    });
})(jQuery);
